import Image from "next/image";

export default function MadeToMeasureIntro({ content }) {
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-6 flex flex-col md:flex-row items-center gap-8">
        <div className="md:w-1/2">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">{content.title}</h2>
          <h3 className="text-xl text-gray-600 mb-4">{content.subtitle}</h3>
          <p className="text-gray-700 mb-6">{content.description}</p>
          <a href={content.cta.link} className="inline-block bg-black text-white px-6 py-2 rounded hover:bg-gray-800 transition">
            {content.cta.label}
          </a>
        </div>
        <div className="md:w-1/2">
          <Image
            src={content.image}
            alt={content.title}
            width={600}
            height={400}
            className="rounded shadow"
          />
        </div>
      </div>
    </section>
  );
}